import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CanonicalService } from '../../../shared/seo/canonical.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-email-verification',
  imports: [FormsModule,CommonModule,RouterLink,MatIconModule],
  templateUrl: './email-verification.component.html',
  styleUrl: './email-verification.component.scss',
   encapsulation: ViewEncapsulation.None  // ✅ Make sure this line is here
})
export class EmailVerificationComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta,private canonicalService: CanonicalService) { }

  ngOnInit(): void {
    // Set page title
    this.titleService.setTitle('Email Verification | Validate Lists by MALtech');

    // Set meta description
    this.metaService.updateTag({
      name: 'description',
      content: 'Email verification helps ensure emails reach inboxes by preventing hard bounces, reducing spam issues, and filtering invalid email addresses.'
    });

    // Optional: SEO enhancements
    this.metaService.updateTag({ name: 'robots', content: 'index, follow' });

    this.canonicalService.setCanonicalURL('product/email-verifier/');

 }
 
 emailCount: number = 0;
  currentCurrency: 'USD' | 'INR' = 'USD';
  conversionRate: number = 83; // USD → INR

  rates = [
    { limit: 10000, price: 0.0043 },
    { limit: 50000, price: 0.0029 },
    { limit: 100000, price: 0.0026 },
    { limit: 250000, price: 0.0018 },
    { limit: 500000, price: 0.0016 },
    { limit: 1000000, price: 0.0011 }
  ];

  get price(): string {
     if (this.emailCount > 1000000) {
    return `Over 1,000,000 – Contact Us.`;
  }
    let rate = 0;

    for (let r of this.rates) {
      if (this.emailCount <= r.limit) {
        rate = r.price;
        break;
      }
    }

    let total = this.emailCount * rate;

    if (this.currentCurrency === 'INR') {
      total *= this.conversionRate;
      return `₹${total.toFixed(2)}`;
    } else {
      return `$${total.toFixed(2)}`;
    }
  }

  setCurrency(currency: 'USD' | 'INR') {
    this.currentCurrency = currency;
  }

  features = [
    {
      icon: 'bi-shield-check',
      title: '99% Accuracy',
      text: 'Eliminate invalid and risky emails with high precision.'
    },
    {
      icon: 'bi-diagram-3',
      title: 'Scalable Solutions',
      text: 'From startups to enterprises, we handle millions of emails seamlessly.'
    },
    {
      icon: 'bi-shield-lock',
      title: 'Secure & Compliant',
      text: 'Your data stays protected with enterprise-grade security.'
    },
    {
      icon: 'bi-arrow-repeat',
      title: 'Real-Time Verification',
      text: 'Validate emails instantly with our powerful API.'
    },
    {
      icon: 'bi-headset',
      title: '24/7 Support',
      text: 'Always here to help you with quick resolutions.'
    }
  ];
  activeIndex: number | null = null;

  accordionItems = [
    { title: 'Email Verification', content: 'Email Verification is verifying invalid email Ids that are not real and spam listed. The primary goal of email validation is to ensure that you don\'t have any spam trap addresses that could damage your sending reputation.' },
    { title: 'Email List Verification', content: 'An email list verification examines an email address list that sends mass emails to an unintended group of recipients.' },
    { title: 'Bulk Email Verification', content: 'You can verify or clean up your email list and reduce your bounce rate by up to 98% using MALtech\'s online email validation system. Isn\'t that fantastic?' },
    { title: 'Email Validation API', content: 'Our custom real-time API validates both single emails and bulk lists in JSON, making it the most efficient solution for email marketing campaigns.' }
  ];

  toggle(index: number) {
    this.activeIndex = this.activeIndex === index ? null : index;
  }
  
  scrollToPlans() {
  const plansSection = document.getElementById('plans');
  if (plansSection) {
    plansSection.scrollIntoView({ behavior: 'smooth' });
  }
}
   

}
